import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
	state: {
		mediaSelect: {
			title: '',
			show: false,
			callback: null,
			type: 'any',
			allowedMimeTypes: []
		},
		librarySelect: {
			title: '',
			show: false,
			callback: null,
			type: 'any',
			allowedMimeTypes: []
		},
	},
	mutations: {
		CLOSE_LIBRARY: state => {
			state.mediaSelect = {
				title: '',
				show: false,
				callback: null,
				type: 'any',
				allowedMimeTypes: []
			}
			state.librarySelect = {
				title: '',
				show: false,
				callback: null,
				type: 'any',
				allowedMimeTypes: []
			}
		},
		MEDIA_SELECT: (state, { callback, type = 'all', title = 'Select a File...', allowedMimeTypes = [] }) => {
			state.mediaSelect.show = false

			state.mediaSelect = {
				show: true,
				callback,
				type,
				title,
				allowedMimeTypes
			}
		},
		LIBRARY_SELECT: (state, { callback, type = 'all', title = 'Select from the Library...', allowedMimeTypes = [] }) => {
			state.mediaSelect.show = false
			state.mediaSelect = {
				show: true,
				callback,
				type,
				title,
				allowedMimeTypes
			}
		},
		UPDATE_USER(state, user) {
			state.user = user
		},
	},


}
